import React, { Component } from 'react'
import { Button } from '@drifthq/tide-core'
import { OnboardingHeader } from 'components/OnboardingHeader'
import WordPressLogo from './wordpress-text-logo.svg'
import TitleCard from "components/OnboardingTitleCard"
import BackButton from 'components/OnboardingBackButton'

import './style.css'

class ConfigureWordPress extends Component {

  renderTitle() {
    return (
      <img src={WordPressLogo}
        className="wordpress-install-logo"
        alt="wordpress"
      />
    )
  }

  handleClickNext = () => {
    const { history, path } = this.props
    history.push(path + '/wordpress/snippet')
  }

  render() {
    return (
      <div className="wordpress-install-wrapper">
        <OnboardingHeader
          title="Install Drift with WordPress"
          description="Don’t worry — installing Drift won’t make any changes to your site now!"
        />
        <TitleCard title={this.renderTitle()} className="wordpress-install-card">
          <div className="wordpress-install-card-body">
            Download the Drift Plugin and upload it to your WordPress site. Learn more about how to upload a plugin
          <a href="https://codex.wordpress.org/Managing_Plugins" target="_blank"
              rel="noopener noreferrer"> here.</a>
            <a
              href="https://help.drift.com/article/install-drift-on-your-wordpress-site/"
              target="_blank"
              rel="noopener noreferrer"
              >
              <div className="wordpress-install-card-doc-link">Drift / WordPress Documentation</div>
          </a>
            <br />
            <a
              href="https://wordpress.org/plugins-wp/drift/"
              target="_blank"
              rel="noopener noreferrer"
              className="button-wrap"
            >
              <Button type="tertiary" className="wordpress-install-card-button">
                Download the Drift Plugin
            </Button>
            </a>
          </div>
        </TitleCard>
        <Button onClick={this.handleClickNext} className="wordpress-install-next-button" size="large">
          Next
          </Button>
          <BackButton/>
      </div>
    )
  }
}

export default ConfigureWordPress


// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/WordPressInstall/index.js